import { render, staticRenderFns } from "./SuggestField.vue?vue&type=template&id=16950a27"
import script from "./SuggestField.vue?vue&type=script&lang=js"
export * from "./SuggestField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports